import { useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import { handleAddPackagePriceOpe } from '../../ProductOperation';
import AddDurationType from './AddDurationType';
import AddLifetimeType from './AddLifetimeType';
import AddPpuType from './AddPpuType';

const initialData = {
    id: 0,
    currency: '',
    amount: 0,
    vatPercent: 0,
    priority: 0,
    limitByBillingCycle: 0,
    LimitByValue: 1,
    packageUnitName: 'month',
    limitByPPU: 0,
    status: 'active'
};

function InputByPackagePriceType({ type, formData, handleChange }) {
    if (type === 'duration') {
        return <AddDurationType formData={formData} handleChange={handleChange} />;
    }
    if (type === 'ppu') {
        return <AddPpuType formData={formData} handleChange={handleChange} />;
    }
    if (type === 'lifetime') {
        return <AddLifetimeType formData={formData} handleChange={handleChange} />;
    }
    return null;
}

function AddPackagePriceModal({ closeModal, handleReload, data }) {
    const [formData, setFormData] = useState({ Id: data?.id, ...initialData });
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const { setMessage } = useTemplate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };
    const handleAdd = (e) => {
        setLoading(true);
        e.preventDefault();
        handleAddPackagePriceOpe(data?.applicationId, data?.id, formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                closeModal();
                handleReload();
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleAdd}>
            <InputByPackagePriceType
                type={data?.limitBy}
                formData={formData}
                handleChange={handleChange}
            />
            <div className="flex gap-x-2 justify-end">
                <ButtonCancel title="Cancel" onClick={closeModal} />
                <ButtonPrimary title="Add" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default AddPackagePriceModal;
